export const getNumber = (num: any, defaultNumber = 1): number => {
  return typeof(num) === 'number' ? num : defaultNumber
}